import { ROLE_TYPES } from '../../../constants/constants.js';

export const PRODUCTION_AUTOMATION_ROLE_IDS = Object.freeze([
  ROLE_TYPES.管理员,
  ROLE_TYPES.制作人员,
]);

export const canUseProductionAutomation = (role) =>
  PRODUCTION_AUTOMATION_ROLE_IDS.includes(Number(role));
